import PropTypes from "prop-types"
import React from "react"

import { Box } from "components/common/index"

const VibeImageBlock = ({
  display = "block",
  maxWidth = "100%",
  ml,
  paths
}) => {
  return (
    <Box display={display} flex="1">
      <picture>
        <source
          media="(max-width: 767px)"
          srcSet={`
            ${paths.mobile[0]} 1x,
            ${paths.mobile[1]} 2x
          `}
        />
        <source
          media="(min-width: 768px)"
          srcSet={`
            ${paths.desktop[0]} 1x,
            ${paths.desktop[1]} 2x
          `}
        />
        <Box as="img" maxWidth={maxWidth} ml={ml} src={`${paths.desktop[1]}`} />
      </picture>
    </Box>
  )
}

VibeImageBlock.propTypes = {
  display: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  ml: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  paths: PropTypes.object.isRequired
}

export default VibeImageBlock
